import React, { Suspense, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import ErrorBoundary from '../../ErrorBoundary';
import useStyles from './styles';
import SubscriptionHandler from '../subscriptionHandler';
import AccessControl from '../../../components/AccessControl';
const Dashboard = lazy(() => import('../../SubscriberDashboard'));
const SubscriptionFallBackUI = lazy(() => import('../../SubscriptionFallBackUI'));
const NewCal = lazy(() => import('../../publish/scheduler'))
const Drafts = lazy(() => import('../../publish/drafts'))
const AccountManager = lazy(() => import('../../AccountManager'));
const FileManager = lazy(() => import('../../FileManager'));
const TeamManager = lazy(() => import('../../TeamManager'));
const NewPost = lazy(() => import('../../publish/compose'));
const Mentions = lazy(() => import('../../Mentions'));
const Analytics = lazy(() => import('../../SocialSettings'));
const LogsManager = lazy(() => import('../../LogsManager'));

const MainContent = ({ isMenuOpen }) => {
    const classes = useStyles();
    return (
        <main className={isMenuOpen ? classes.content : classes.sidebarCollapse}>
            <Suspense fallback={<CircularProgress className={classes.progress} />}>
                <SubscriptionHandler>
                    <Switch>
                        <Route exact path="/" key="/" render={() => (
                            <ErrorBoundary>
                                <Dashboard />
                            </ErrorBoundary>
                        )} />
                        <Route exact path="/not-subscribed" key="/not-subscribed" render={() => (
                            <ErrorBoundary>
                                <SubscriptionFallBackUI />
                            </ErrorBoundary>
                        )} />

                        <Route path="/calendar" key="/calendar" render={() => (
                            <ErrorBoundary>
                                <NewCal />
                            </ErrorBoundary>
                        )} />

                        <Route path="/analytics" key="/analytics" render={() => (
                            <ErrorBoundary>
                                <Analytics />
                            </ErrorBoundary>
                        )} />

                        <Route path="/new-post" key="/new-post" render={() => (
                            <ErrorBoundary>
                                <NewPost />
                            </ErrorBoundary>
                        )} />

                        <Route path="/drafts" key="/drafts" render={() => (
                            <ErrorBoundary>
                                <Drafts />
                            </ErrorBoundary>
                        )} />

                        <Route path="/socialInbox" key="/socialInbox" render={() => (
                            <ErrorBoundary>
                                <Mentions />
                            </ErrorBoundary>
                        )} />

                        <Route path="/brands" key="/brands" render={() => (
                            <ErrorBoundary>
                                <AccountManager />
                            </ErrorBoundary>
                        )} />

                        <Route path="/contentCuration" key="/contentCuration" render={() => (
                            <ErrorBoundary>
                                <FileManager />
                            </ErrorBoundary>
                        )} />

                        <Route path="/team" key="/team" render={() => (
                            <ErrorBoundary>
                                <TeamManager />
                            </ErrorBoundary>
                        )} />

                        <Route path="/logs" key="/logs" render={() => (
                            <ErrorBoundary>
                                <LogsManager />
                            </ErrorBoundary>
                        )} />

                    </Switch>
                </SubscriptionHandler>
            </Suspense >
        </main >
    );
};

export default MainContent;
